import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { LogService } from 'src/app/shared/services/log.service';
import { Note } from '../models/note.model';
import { DonationHistoryComponent } from 'src/app/member/donation-history/donation-history.component';
import { GetDonationHistory } from '../models/get-donation-history.model';
import { GivingType } from '../models/giving-type.model';
import { SaveGivingType } from '../models/save-giving-type.model';
import { SaveDonation } from '../models/save-donation.model';
import { PossibleAccount, PossibleAccountWrapper } from '../models/possible-account.model';
import { DonationRequest } from '../models/donation-request';

@Injectable({ providedIn: 'root' })
export class DonationService {
  apiHost: string = environment.apiHost;
  constructor(
    private http: HttpClient,
    private router: Router,
    private logService: LogService
  ) {}

  getFunds(): Promise<string[]> {
    let promise = new Promise<string[]>((resolve, reject) => {
      return this.http
        .get<string[]>(
          this.apiHost +
            '/donation/getFunds' 
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data['dataResult']);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: Unable to get funds!',
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;
  }  

  getDonationsByMember(memberId: string): Promise<GetDonationHistory> {
    let promise = new Promise<GetDonationHistory>((resolve, reject) => {
      return this.http
        .get<GetDonationHistory>(
          this.apiHost +
            '/donation/GetDonationByMember?MemberId=' +
            memberId
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data['dataResult']);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: Get Member Donations',
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;
  }

  getFlagDonationMember(memberId: string): Promise<GetDonationHistory> {
    let promise = new Promise<GetDonationHistory>((resolve, reject) => {
      return this.http
        .get<GetDonationHistory>(
          this.apiHost +
            '/donation/GetFlagDonationByMember?MemberId=' +
            memberId
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data['dataResult']);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: Get Members Deleted Donations',
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;
  }  

  getDonationGroup(donationRequest: DonationRequest, subdomain: string, allChurches: boolean = false): Promise<GetDonationHistory> {
    let promise = new Promise<GetDonationHistory>((resolve, reject) => {
      return this.http
        .post<GetDonationHistory>(
          this.apiHost +
            '/donation/GetDonationGroup?subdomain=' +
            subdomain, donationRequest
        ) 
        .toPromise()
        .then( 
          (data) => {
            resolve(data['dataResult']);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: Get Member Donations',
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;
  }

  GetAllGivingTypes(): Promise<GivingType[]> {
    let promise = new Promise<GivingType[]>((resolve, reject) => {
      return this.http
        .get<GivingType[]>(
          this.apiHost +
            '/donation/GetAllGivingTypes'
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data['dataResult']);
          },  
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: Get All Giving Types',
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;
  } 

  GetPossibleAccounts(memberId: number): Promise<PossibleAccountWrapper> {
    let promise = new Promise<PossibleAccountWrapper>((resolve, reject) => {
      return this.http
        .get<PossibleAccountWrapper[]>(
          this.apiHost +
            '/donation/GetPossibleAccounts?MemberId=' + memberId
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data['dataResult']);
          },  
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: Get Possible Accounts',
                msg
              );
            reject(msg);
          }
        );
    }); 
    return promise;
  }   

  LinkAccounts(linkAccounts: PossibleAccountWrapper): Promise<PossibleAccountWrapper> {
    let promise = new Promise<PossibleAccountWrapper>((resolve, reject) => {
      return this.http
        .post<PossibleAccountWrapper>(
          this.apiHost +
            '/donation/LinkDonationAccounts', linkAccounts
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data['dataResult']);
          },  
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: Link Donation Accounts',
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;

  }

  SetAllGivingTypes(SaveGivingTypes: SaveGivingType[]): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(
          this.apiHost +
            '/donation/SetAllGivingTypes',SaveGivingTypes
        )
        .toPromise()
        .then(
          (data) => {
            resolve(true);
          },  
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: Set All Giving Types',
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;
  }
  
  AddDonation(donation: SaveDonation): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(
          this.apiHost +
            '/donation/AddManualDonation', donation
        )
        .toPromise()
        .then(  
          (data) => {
            resolve(true);
          },  
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog( 
                'Admin: Failed to add manual donation',
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;
  }

  FlagDonation(transactionId: string, flag: boolean): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(
          this.apiHost +
            '/donation/FlagDonation?ChargeId=' + transactionId + '&Flag=' + flag.toString(), null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(true);
          },  
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: Failed to flag donation',
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;
  }  

  SaveDonation(transactionId: string, donation: SaveDonation): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(
          this.apiHost +
            '/donation/SaveDonationDetail?TransactionId=' + transactionId, donation
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data['dataResult']);
          },  
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: Update Manual Donation',
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;
  }  

  GetDonationDetail(transactionId): Promise<SaveDonation> {
    let promise = new Promise<SaveDonation>((resolve, reject) => {
      return this.http
        .get<SaveDonation>(
          this.apiHost +
            '/donation/GetDonationDetail?TransactionId=' + transactionId
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data['dataResult']);
          },  
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: Get Donation Detail',
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;
  }   
}
